import React, { useState } from "react";

import Header from "../component/header"
import Footer from "../component/footer"

import "./dashboard.css"
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';


const Login = () => {
    const navigate = useNavigate();
    const [inputUsername, setInputUsername] = useState("");
    const [inputPassword, setInputPassword] = useState("");
    // const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
  
    const handleSubmit = async (event) => {
      event.preventDefault();
      setLoading(true);
  
      try {
        const response = await fetch("https://arkane.in/apijob/login.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username: inputUsername,
            password: inputPassword,
          }),
        });
  
        const data = await response.json();
  
        if (data.success) {
          // Store token in local storage or state
          localStorage.setItem("token", data.token);
          toast.success('Login successful');
          // Redirect to dashboard
          navigate("/arkane-job-crm");
       
        } else {
          // setShow(true);
          toast.error('Invalid username or password!');
        }
      } catch (error) {
        // console.error("Login failed:", error);
        // setShow(true);
        toast.error('Invalid username or password!');
      }
  
      setLoading(false);
    };
    return (
         <>
               <Header/>
        <div
          className="sign-in__wrapper"
        >
          <ToastContainer/>
          {/* Overlay */}
          <div className="sign-in__backdrop"></div>
          {/* Form */}
          <form
      className="shadow p-4 bg-black rounded"
      onSubmit={handleSubmit}
    >
  

      {/* Username */}
      <div className="mb-2">
        {/* <label className="form-label">Username</label> */}
        <input
          type="text"
          className="form-control contacts-input"
          value={inputUsername}
          placeholder="Username"
          onChange={(e) => setInputUsername(e.target.value)}
          required
        />
      </div>

      {/* Password */}
      <div className="mb-2">
        {/* <label className="form-label">Password</label> */}
        <input
          type="password"
          className="form-control contacts-input"
          value={inputPassword}
          placeholder="Password"
          onChange={(e) => setInputPassword(e.target.value)}
          required
        />
      </div>

      {/* Remember Me */}
      <div className="mb-2 form-check">
         <div className="mb-container">
          <input
          type="checkbox"
          className="form-check-input"
          id="rememberMe"
        />
        <label className="form-check-label" htmlFor="rememberMe">
          Remember me
        </label>
         </div>
      </div>

      {/* Button */}
      <button
        className="btn btn-primary w-100"
        type="submit"
        disabled={loading}
      >
        {loading ? "Logging In..." : "Log In"}
      </button>
    </form>
          {/* Footer */}
        
        </div>
        <Footer/>
         </>
      );
    };
    
    export default Login;